import httpService from "./http.service";

class CartInquiryService {
  url = "/cart-inquiry";

  getCartInquiry = (status = 'pending') => {
    return httpService.get(`/cart-inquiry?status=${status}`);
  };

  getUserCartDetail = (userId) => {
    return httpService.get(`/cart/userCart/${userId}`);
  };

  answerdCartInquiry = async (reqId, data) => {
    await httpService.patch(`/cart-inquiry/change-answered/${reqId}`, data);
    return 
  };
}

const cartInquiryService = new CartInquiryService();
export default cartInquiryService;
